import React, { FC } from 'react';
import { IconButton } from '@mui/material';

interface ActionButtonConfig {
  icon: React.ReactNode;
  color?: 'default' | 'inherit' | 'primary' | 'secondary' | 'error';
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  disabled?: boolean;
  className: string;
  size?: 'small' | 'medium' | 'large';
}

interface ActionButtonsProps {
  configs: ActionButtonConfig[];
  classes: any;
}

export const ActionButtons: FC<ActionButtonsProps> = ({ configs, classes }) => {
  return (
    <div className={classes.buttonsWrapper}>
      {configs.map((config, index) => (
        <IconButton
          key={index}
          className={config.className}
          color={config.color}
          disabled={config.disabled}
          onClick={config.onClick}
          size={config.size || 'large'} 
        >
          {config.icon}
        </IconButton>
      ))}
    </div>
  );
};

export default ActionButtons;
